//@flow

import React from "react";

export default function trendIndicator(valA: number, valB: number, displayVal: string | number) {
  let bkgColor = "";

  if (valA < valB) {
    bkgColor = "transform-rotate-270 text-color-risk-very-high";
  } else if (valA > valB) {
    bkgColor = "transform-rotate-90 text-color-risk-low";
  } else {
    bkgColor = "transform-rotate-0 text-color-risk-medium";
  }
  return (
    <div className="d-flex justify-content-center align-items-center flex-1">
      <span className="pr-2">{displayVal}</span>
      <div className={`fs-14 material-icons ${bkgColor}`}>double_arrow</div>
    </div>
  );
}
